import { localized, t } from '@weavedev/lit-i18next';
import { LitElement, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

import { PrintOptionStepDto } from '@/api-sdk';

import './fg-print-option';

@customElement('fg-print-option-list')
@localized()
export class FgPrintOptionList extends LitElement {
  /**
   * Object containing the print option data
   */
  @property({ type: Array })
  options: PrintOptionStepDto['selectedOptions'] = [];

  @property({ type: String })
  excludedPrintOptionCode: string | null = null;

  render() {
    return html`
      ${this.options
        .filter(option => option.code !== this.excludedPrintOptionCode)
        .map((option, index) => {
          const titleIndex = index + 1;
          return html`
            <fg-print-option
              .title=${t('headers.printPosition', {
                positionIndex: titleIndex,
              }) || ''}
              .option=${option}
            ></fg-print-option>
          `;
        })}
    `;
  }
}
